import type { CSSProperties, JSX } from 'react';
import type { Palette } from '../../../../_theme/palette.js';
import type { SurveyQuestion } from '../../types.js';
import { DateField } from './DateField.js';

interface DateRangeFieldProps {
  palette: Palette;
  question: SurveyQuestion;
  value: unknown;
  onChange: (value: { start?: string; end?: string }) => void;
}

// Two date inputs labelled "Start date" / "End date" with the same themed
// calendar icon pattern as the single date field.
export function DateRangeField({ palette, value, onChange }: DateRangeFieldProps): JSX.Element {
  const current = (value as { start?: string; end?: string }) ?? {};
  return (
    <div style={rowStyle()}>
      <div style={cellStyle()}>
        <label style={labelStyle(palette)}>Start date</label>
        <DateField
          palette={palette}
          type="date"
          value={current.start ?? ''}
          onChange={(start) => onChange({ ...current, start })}
          ariaLabel="Start date"
        />
      </div>
      <span style={separatorStyle(palette)}>to</span>
      <div style={cellStyle()}>
        <label style={labelStyle(palette)}>End date</label>
        <DateField
          palette={palette}
          type="date"
          value={current.end ?? ''}
          onChange={(end) => onChange({ ...current, end })}
          ariaLabel="End date"
        />
      </div>
    </div>
  );
}

function rowStyle(): CSSProperties {
  return { display: 'flex', alignItems: 'flex-end', gap: 10 };
}

function cellStyle(): CSSProperties {
  return { flex: 1, minWidth: 0 };
}

function labelStyle(palette: Palette): CSSProperties {
  return {
    display: 'block',
    fontSize: 11,
    color: palette.textMuted,
    marginBottom: 4,
  };
}

function separatorStyle(palette: Palette): CSSProperties {
  return {
    color: palette.textMuted,
    fontSize: 13,
    paddingBottom: 14,
  };
}
